<p-dialog [(visible)]="dialogVisible" [modal]="true" [style]="{ width: '100%', height: '100%' }"
    (onHide)="closeDialog()" [closable]="true">
    <ng-template pTemplate="content">
        <ng-container *ngIf="dialogVisible">
            <app-jedinica-hierarchy-picker></app-jedinica-hierarchy-picker>
        </ng-container>
    </ng-template>
</p-dialog>